site.fontLarger = {
	init: function () {
		// The current scale of the site, if the cookie has been set
		var currentZoom;

		var minZoom = 1.0;
		var maxZoom = 1.3;
		var stepZoom = 0.1;

		$('#zoomUp').on('click touchStart', function (e) {
			currentZoom = parseFloat(getCookie('sitezoom')) || minZoom;
			if (currentZoom < maxZoom) {
				currentZoom += stepZoom;
			}
			$('body').css('zoom', currentZoom);
			document.cookie = 'sitezoom=' + currentZoom + ';path=/';
		});
		$('#zoomDown').on('click touchStart', function (e) {
			currentZoom = parseFloat(getCookie('sitezoom')) || minZoom;
			if (currentZoom > minZoom) {
				currentZoom -= stepZoom;
			}
			$('body').css('zoom', currentZoom);
			document.cookie = 'sitezoom=' + currentZoom + ';path=/';
		});

		currentZoom = parseFloat(getCookie('sitezoom')) || minZoom;
		$('body').css('zoom', currentZoom);
	}
};

function getCookie(name) {
	var value = "; " + document.cookie;
	var parts = value.split("; " + name + "=");
	if (parts.length == 2) return parts.pop().split(";").shift();
}

site.inits.push('site.fontLarger.init()');
